import React, {
  useEffect,
  useRef,
  forwardRef,
  useState,
  useImperativeHandle,
} from "react";
import JSMpeg from "@cycjimmy/jsmpeg-player";
import { useAxiosWithAuthorization } from "../../../utils/api";
import axios from "axios";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import backColor from "../../../images/back.png";

const Viewer = forwardRef((props, ref) => {
  const [milestoneInfo, setMilestoneInfo] = useState(null);
  const cameraRef = useRef();
  const imageRef = useRef();
  const [player, setPlayer] = useState(null);
  const [visbile, setVisible] = useState(false);
  const [imageVisbile, setImageVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    onCameraDestory() {
      //console.log(player);
      //console.log(props.rtspUrl);

      if (player !== null) {
        player.destroy();
        setPlayer(null);
        setImageVisible(false);
      }
    },
    onCameraStart(cameraInfo) {
      //console.log(player);
      //console.log(cameraInfo);

      setVisible(true);
      setRtsp(cameraInfo);
      setVisible(false);
      setImageVisible(true);
    },

    initMilestone(cameraGuid, milestone, inspNo) {
      setMilestoneInfo({
        ...milestone,
        ["cameraGuid"]: cameraGuid,
        ["inspNo"]: inspNo,
      });
    },

    setPTZ(direction) {
      putPTZ(direction);
    },
    onCameraStop() {
      if (player !== null) {
        player.stop();
      }
    },
  }));

  useEffect(() => {
    if (player === null) {
      //loadImage();
    }
  }, []);

  const loadImage = () => {
    if (!cameraRef) return;
    const ctx = cameraRef.current.getContext("2d");
    console.log(ctx);
    const image = new Image();
    image.src = backColor;
    image.onload = function () {
      //입력 파일의 크기를 알아냄

      console.log("width", image.width);
      var inW = image.width;
      var inH = image.height;

      // 캔버스 크기를 결정
      cameraRef.current.width = inW;
      cameraRef.current.height = inH;

      //console.log("canvas - width",outCanvas.width);
      ctx.drawImage(image, 0, 0, inW, inH);
    };
  };

  const setCameraDestory = async () => {
    //console.log(player);
    if (player !== null) {
      await player.destroy();
      setPlayer(null);
      loadImage();
    }
  };

  //const CAMERA_PLAY_URL = "http://localhost:7090/stream/play";
  //const CAMERA_PLAY_URL = "http://192.168.20.216:8080/stream/play";
  //const CAMERA_PLAY_URL = "http://192.168.70.43:8080/stream/play";
  //const CAMERA_PLAY_URL = "http://imsrelay.idaehan.com:8080/stream/play";
  const CAMERA_PLAY_URL = "https://imsrelay.idaehan.com:8443/stream/play";

  //const CAMERA_PLAY_URL_YK = "http://localhost:7090/stream/play";
  //const CAMERA_PLAY_URL_YK = "https://imsrelayns.yksteel.co.kr:8443/stream/play";
  const CAMERA_PLAY_URL_YK = "https://imsrelaygp.idaehan.com:8443/stream/play";

  //현재 임시 대한제강 임시 서버 로딩시 사용
  //const CAMERA_PLAY_URL_DH = "http://localhost:7090/stream/play";
  //const CAMERA_PLAY_URL_DH = "http://imsrelayns.idaehan.com:8080/stream/play";
  //const CAMERA_PLAY_URL_DH = "http://192.168.20.216:8080/stream/play";
  //const CAMERA_PLAY_URL_DH = "https://192.168.20.216:8443/stream/play";
  const CAMERA_PLAY_URL_DH = "https://imsrelayns.idaehan.com:8443/stream/play";

  //현재 임시 대한제강 NRC 1야드 서버 로딩시 사용
  const CAMERA_PLAY_URL_NRC =
    "https://imsrelaynrc.idaehan.com:8443/stream/play";

  //const CAMERA_PLAY_URL_NRC = "http://localhost:7090/stream/play";

  //const MILESTONE_PTZ_URL = "http://localhost:7090/milestone/PTZ";
  //const MILESTONE_PTZ_URL = "http://192.168.20.216:8080/milestone/PTZ";
  //const MILESTONE_PTZ_URL = "http://imsns.idaehan.com:8080/milestone/PTZ";
  const MILESTONE_PTZ_URL = "https://imsns.idaehan.com:8443/milestone/PTZ";

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: CAMERA_PLAY_URL,
    },
    { manual: true }
  );

  const setRtsp = async (cameraInfo) => {
    var isConnect = true;
    var url =
      cameraInfo.scrapAreaCd.indexOf("1200") >= 0
        ? cameraInfo.scrapAreaCd.indexOf("1200N") >= 0
          ? CAMERA_PLAY_URL_NRC
          : CAMERA_PLAY_URL_DH
        : CAMERA_PLAY_URL_YK;
    let response = await axios({
      method: "POST",
      url: url,
      data: cameraInfo,
    }).catch(function (error) {
      isConnect = false;
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error("영상중계 오류 : " + error.response.data.error.message);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });

    if (!isConnect) {
      cameraInfo.resolution = "1024X768";
      cameraInfo.frame = "20";
      cameraInfo.bitrate = "800";
      //console.log(cameraInfo);

      response = await axios({
        method: "POST",
        url: CAMERA_PLAY_URL,
        data: cameraInfo,
      }).catch(function (error) {
        isConnect = false;
        if (error.response) {
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          //console.log(error.response.data);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          toast.error("영상중계 오류 : " + error.response.data.error.message);
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          //console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          //console.log("Error", error.message);
        }
        //console.log(error.config);
      });
    }

    console.log(response.data.data);
    await setCameraDestory();
    sleep(500);
    if (response.data.data.path !== null) {
      const jsPlayer = new JSMpeg.Player(response.data.data.path, {
        canvas: cameraRef.current,
        //autoplay: true,
      });
      //console.log(jsPlayer);
      setPlayer(jsPlayer);
      sleep(500);
      jsPlayer.play();

      return () => {
        player.destroy();
      };
    } else {
    }
  };

  const putPTZ = async (direction) => {
    const response = await axios({
      method: "GET",
      url: MILESTONE_PTZ_URL,
      params: {
        cameraGuid: milestoneInfo.cameraGuid,
        direction: direction,
        serverIp: milestoneInfo.serverIp,
        userId: milestoneInfo.userId,
        userPassword: milestoneInfo.userPassword,
        serverServiceUrl: milestoneInfo.serverServiceUrl,
        recorderServiceUrl: milestoneInfo.recorderServiceUrl,
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error("PTZ 오류 : " + error.response.data.error.message);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });
  };

  const onDirectClick = (event) => {
    const { name, value } = event.target;
    //console.log(value);
    putPTZ(value);
    event.stopPropagation();
  };

  const onSnapShot = (event) => {
    props.onSnapShot(milestoneInfo.cameraGuid);
    event.stopPropagation();
  };
  return (
    <>
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="96"
        visible={visbile}
      />
      <canvas
        ref={cameraRef}
        id="video-canvas"
        className="Viewer"
        hidden={!imageVisbile}
      ></canvas>
      <canvas
        ref={imageRef}
        id="image"
        className="Viewer"
        hidden={imageVisbile}
      ></canvas>
      {/* <div className="direction">
        <div className="circle">
          <button
            type="button"
            className="left"
            onClick={onDirectClick}
            value="left"
          ></button>
          <button
            type="button"
            className="up"
            onClick={onDirectClick}
            value="up"
          ></button>
          <button
            type="button"
            className="down"
            onClick={onDirectClick}
            value="down"
          ></button>
          <button
            type="button"
            className="right"
            onClick={onDirectClick}
            value="right"
          ></button>
        </div>
        <button
          type="button"
          className="stop"
          onClick={onSnapShot}
          value="stop"
        ></button>
        <button
          type="button"
          className="plus"
          onClick={onDirectClick}
          value="zoomin"
        ></button>
        <button
          type="button"
          className="minus"
          onClick={onDirectClick}
          value="zoomout"
        ></button> 
      </div>*/}
    </>
  );
});

export default React.memo(Viewer);
